import { HttpClient } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { executeNavbarAction } from '../shared-navbar/navbar-actions';
import { NavbarMenuItem } from '../shared-navbar/navbar-config';
import { UserManagementService } from '../user-management/user-management.service';

@Component({
  selector: 'app-all-role-nav',
  templateUrl: './all-role-nav.component.html',
  styleUrls: ['./all-role-nav.component.css'],
  standalone: false,
})
export class AllRoleNavComponent implements OnInit, OnDestroy {
  @ViewChild('siteEditStatusDialog') siteEditStatusDialog: any;

  public user: any;
  public siteinfo: any;
  public allocatedSite: any;
  public sitename = '';
  public avatarUrl = './assets/images/avathar.jpg';
  public imageSrc: SafeUrl | string = this.avatarUrl;
  public menuItems: NavbarMenuItem[] = [];
  public profileMenuItems: NavbarMenuItem[] = [{ label: 'Logout', actionId: 'logout' }];
  public showNotifications = true;
  public notificationPermission = null;
  public navbarClass = 'navbar navbar-expand-lg bg-custom boxshadow fixed-top';

  private subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    private userService: UserManagementService,
    private modalService: NgbModal,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.user = this.userService.getUserDetail();
    this.siteinfo = this.userService.getSiteDetail();
    this.allocatedSite =
      this.userService.getCurrentSite() || this.siteinfo?.[0]?.site_id || null;
    this.sitename =
      this.userService.getCurrentSitename() || this.siteinfo?.[0]?.site_name || '';
    this.menuItems = this.buildMenuItems();

    const userId = this.user?.id || this.user?.user_id;
    if (userId) {
      this.loadUserImage(userId);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  onNavbarAction(actionId: string): void {
    void executeNavbarAction(actionId, {
      router: this.router,
      userService: this.userService,
      allocatedSite: this.allocatedSite,
      user: this.user,
      http: this.http,
      modalService: this.modalService,
      siteEditStatusDialog: this.siteEditStatusDialog,
      clearFilterSelections: () => this.clearAllFilterSelections(),
    });
  }

  private buildMenuItems(): NavbarMenuItem[] {
    return [
      {
        id: 'mapCorp',
        label: 'MAP',
        route: '/corporation/map-corp',
      },
      {
        id: 'categoryDashboard',
        label: 'CATEGORY',
        route: '/corporation/corporate-dashboard',
      },
      {
        id: 'statisticsMenu',
        label: 'STATISTICS',
        children: [
          {
            label: 'CATEGORY',
            route: '/report-system/dashboard-group-list',
            queryParams: { type: 'corporate', subtype: 'category' },
            dividerAfter: true,
          },
          {
            label: 'PLANT',
            route: '/report-system/dashboard-group-list',
            queryParams: { type: 'corporate', subtype: 'plant' },
            dividerAfter: true,
          },
          {
            label: 'EXECUTIVE ALL REPORT',
            route: '/report-system/dashboard-group-list',
            queryParams: { type: 'executive' },
          },
        ],
      },
      {
        id: 'settingsMenu',
        label: 'SETTINGS',
        children: [
          {
            label: 'CORP SETTING',
            route: '/corporation/edit-corp',
            dividerAfter: true,
          },
          {
            label: 'CORP USER SETTING',
            route: '/corporation/manage-corp-user',
            dividerAfter: true,
          },
          {
            label: 'PLANT SETTING',
            route: '/corporation/manage-corp-site',
            dividerAfter: true,
          },
          {
            label: 'CATEGORIES',
            route: '/corporation/categories-listing',
            dividerAfter: true,
          },
          {
            label: 'SITE USERS',
            route: '/site/allsiteuser',
            dividerAfter: true,
          },
          {
            label: 'CREATE SITE USER',
            route: '/site/createsiteuser',
            dividerAfter: true,
          },
          {
            label: 'PLANT CUSTOMIZATION',
            actionId: 'plantCustomization',
            webOnly: true,
            dividerAfter: true,
          },
          {
            label: 'DMS USER SETTING',
            actionId: 'dmsUserSetting',
            dividerAfter: true,
          },
          {
            label: 'PURIFAI USER SETTING',
            actionId: 'purifaiUserSetting',
          },
        ],
      },
      {
        id: 'reportsMenu',
        label: 'REPORTS',
        children: [
          {
            label: 'PROCESS',
            children: [
              {
                label: 'MODULE',
                route: '/dashboard/processdashboard',
                dividerAfter: true,
              },
              {
                label: 'LIST',
                route: '/reportlibrary/editreport/process',
              },
            ],
            dividerAfter: true,
          },
          {
            label: 'OPEX',
            children: [
              {
                label: 'MODULE',
                route: '/dashboard/opexdashboard',
                dividerAfter: true,
              },
              {
                label: 'LIST',
                route: '/dashboard/customeOpexDashboard',
              },
            ],
          },
        ],
      },
      {
        id: 'specialReportsMenu',
        label: 'SPECIAL REPORTS',
        children: [
          {
            label: 'SITE MIX REPORTS',
            route: '/mixdashboard/mix-report-list',
            dividerAfter: true,
          },
          {
            label: 'DASHBOARD GROUP LIST',
            route: '/report-system/dashboard-group-list',
          },
        ],
      },
      {
        id: 'alertsMenu',
        label: 'ALERTS',
        children: [
          {
            label: 'ADVANCED ALERTS',
            route: '/newalerts/alertlist',
            queryParams: { showTableOnly: false },
            dividerAfter: true,
          },
          {
            label: 'OPEN ALERTS',
            route: '/alerts/openalert',
            dividerAfter: true,
          },
          {
            label: 'ALERT HISTORY',
            route: '/alerts/historyalert',
            dividerAfter: true,
          },
          {
            label: 'PM ALERTS',
            route: '/alerts/pmalerts',
            dividerAfter: true,
          },
          {
            label: 'MODULE ALERTS',
            route: '/alerts/modulealerts',
            dividerAfter: true,
          },
          {
            label: 'PARAMETERS ALERTS',
            route: '/alerts/parameteralerts',
            dividerAfter: true,
          },
          {
            label: 'OPEX ALERTS',
            route: '/alerts/opexalerts',
          },
        ],
      },
      {
        id: 'dataUploadMenu',
        label: 'DATA UPLOAD',
        children: [
          {
            label: 'PROCESS',
            route: '/site/uploads/process',
            dividerAfter: true,
          },
          {
            label: 'OPEX',
            route: '/site/uploads/opex',
            dividerAfter: true,
          },
          {
            label: 'SPECIAL LUT',
            route: '/site/dynamic-opex-pricing-list',
            dividerAfter: true,
          },
          {
            label: 'MANAGE MANUAL DATA UPLOAD',
            route: '/uploadagent/managelab',
            dividerAfter: true,
          },
          {
            label: 'MANAGE USERS',
            route: '/uploadagent/managelabusers',
            dividerAfter: true,
          },
          {
            label: 'MANUAL UPLOAD APP',
            route: '/uploadagent/managelabupload',
            dividerAfter: true,
          },
          {
            label: 'DMS',
            actionId: 'dms',
          },
        ],
      },
      {
        id: 'libraryMenu',
        label: 'LIBRARY',
        children: [
          {
            label: 'MODULE SETTINGS',
            children: [
              {
                label: 'PROCESS MODULE',
                children: [
                  {
                    label: 'ADD MODULE',
                    route: '/systemadminlibrary/addModule',
                    dividerAfter: true,
                  },
                  {
                    label: 'EDIT MODULE',
                    route: '/systemadminlibrary/genericlibrary',
                  },
                ],
                dividerAfter: true,
              },
              {
                label: 'OPEX MODULE',
                children: [
                  {
                    label: 'ADD MODULE',
                    route: '/opexmodule/addmodule',
                    dividerAfter: true,
                  },
                  {
                    label: 'EDIT MODULE',
                    route: '/opexmodule/editmodule',
                  },
                ],
                dividerAfter: true,
              },
              {
                label: 'SAFETY MODULE',
                children: [
                  {
                    label: 'ADD MODULE',
                    route: '/safety/addmodule',
                    dividerAfter: true,
                  },
                  {
                    label: 'EDIT MODULE',
                    route: '/safety/editmodule',
                  },
                ],
                dividerAfter: true,
              },
              {
                label: 'EQUIPMENT MODULE',
                children: [
                  {
                    label: 'ADD MODULE',
                    route: '/equipment/addmodule',
                    dividerAfter: true,
                  },
                  {
                    label: 'EDIT MODULE',
                    route: '/equipment/editmodule',
                  },
                ],
              },
            ],
            dividerAfter: true,
          },
          {
            label: 'USER SETTING',
            route: '/useradminlib/useradmin',
            dividerAfter: true,
          },
          {
            label: 'USER PROFILE SETTINGS',
            route: '/site/allgoogleuser',
            dividerAfter: true,
          },
          {
            label: 'USER PROFILE SETTINGS (NEW)',
            route: '/site/user-request',
            dividerAfter: true,
          },
          {
            label: 'USER ROLE',
            route: '/useradminlib/user-role',
            dividerAfter: true,
          },
          {
            label: 'ROLE ACCESS',
            route: '/role',
            dividerAfter: true,
          },
          {
            label: 'REPORT USER MANAGEMENT',
            route: '/report-system/admin/permissions',
            dividerAfter: true,
          },
          {
            label: 'CATEGORY SETTINGS',
            route: '/corporation/categories-settings',
            dividerAfter: true,
          },
          {
            label: 'SUB CATEGORIES SETTINGS',
            route: '/category/editcategory',
            dividerAfter: true,
          },
          {
            label: 'CATEGORY EQUIPMENT SETTINGS',
            route: '/equipment/equipmentsetting',
            queryParams: { categoryEquipmentSetting: true },
            dividerAfter: true,
          },
          {
            label: 'REPORT SETTINGS',
            route: '/reportlibrary/subcategory-report-settings',
            queryParams: { subCategoryReportSetting: true },
            dividerAfter: true,
          },
          {
            label: 'CATEGORY ALERT SETTINGS',
            route: '/newalerts/alertlist',
            queryParams: { categoryAlertSetting: true },
            dividerAfter: true,
          },
          {
            label: 'CS EXPERTS SETTINGS',
            route: '/useradminlib/system-experts',
            dividerAfter: true,
          },
          {
            label: 'AI TOPIC SETTINGS',
            route: '/ai-topic-settings',
          },
        ],
      },
      {
        id: 'dashboardMenu',
        label: 'DASHBOARD',
        children: [
          {
            label: 'PROCESS DB',
            children: [
              {
                label: 'DEFAULT DB',
                route: '/dashboard/processdashboard',
                dividerAfter: true,
              },
              {
                label: 'CUSTOM DB',
                route: '/site/sitedashboard',
              },
            ],
            dividerAfter: true,
          },
          {
            label: 'OPEX DASHBOARD',
            children: [
              {
                label: 'DEFAULT DB',
                route: '/dashboard/opexdashboard',
                dividerAfter: true,
              },
              {
                label: 'CUSTOM DB',
                route: '/dashboard/customeOpexDashboard',
              },
            ],
            dividerAfter: true,
          },
          {
            label: 'CORPORATE DASHBOARD',
            route: '/corporation/corporate-dashboard',
            dividerAfter: true,
          },
          {
            label: 'ALL REPORT',
            route: '/report-system/dashboard-group-list',
            queryParams: { type: 'executive' },
          },
        ],
      },
      {
        id: 'pfdMenu',
        label: 'PFD',
        route: '/site/pdfviewer',
      },
    ];
  }

  private loadUserImage(userId: string | number): void {
    const imageUrl = `${environment.nodeUrl1}user-image/${userId}?t=${Date.now()}`;
    const imageSub = this.http.get(imageUrl, { responseType: 'blob' }).subscribe(
      (blob) => {
        this.imageSrc = this.sanitizer.bypassSecurityTrustUrl(
          URL.createObjectURL(blob)
        );
        this.cdr.detectChanges();
      },
      () => {
        this.imageSrc = this.avatarUrl;
      }
    );
    this.subscriptions.push(imageSub);
  }

  private clearAllFilterSelections(): void {
    try {
      Object.keys(localStorage)
        .filter((key) => key.startsWith('reportFilter_'))
        .forEach((key) => localStorage.removeItem(key));
    } catch (error) {
      console.error('Error clearing filter selections in all-role-nav:', error);
    }
  }
}
